<template>
<v-card>
  <v-card-title class='subtitle-1 overline grey lighten-4 py-0' >
    Assign appointment types to this location
    (<strong class='ml-1'>{{location.name}}</strong>)
    <v-spacer/>
    <v-btn icon @click='$emit("close")' small ><v-icon>close</v-icon></v-btn>
  </v-card-title>

  <v-divider/>
  <request-status :request='setproducts' @ok='$emit("close")' />

  <v-card-text>
    <template v-for='product in products' >

      <v-checkbox hide-details
        v-model='selected'
        class='caption'
        :key='product.id'
        :value='product.id'
        :label='product.title' />

    </template>
  </v-card-text>

  <v-card-actions >
    <v-btn @click='$emit("close")' small flat >Cancel</v-btn>
    <v-spacer/>
    <v-btn
      @click='save'
      :loading="setproducts.loading"
      class="primary" >Set Appointment Types</v-btn>
  </v-card-actions>

</v-card>
</template>
<script>
export default {
  name: 'LocationAssign',
  props: {
    location: { type: Object },
    space: { type: Object }
  },
  data () {
    return {
      selected: [],
      setproducts: {
        resource: 'ag.addresses',
        extra: 'actions/set_products',
        method: 'post'
      }
    }
  },
  watch: {
    requestStatus () {
      if (this.requestStatus === 200) {
        this.$emit('saved', this.setproducts.result)
      }
    },
    locationId: {
      immediate: true,
      handler () {
        this.selected = this.products.filter((product) => {
          return product.locations.indexOf(this.locationId) > -1
        }).map((product) => { return product.id })
      }
    }
  },
  computed: {
    locationId () { return this.getObjectPath(this.location, 'id') },
    products () { return this.getObjectPath(this.space, 'products', []) },
    requestStatus () { return this.setproducts.status }
  },
  methods: {
    save () {
      this.setproducts.resourceId = this.locationId
      this.setproducts.data = {
        new_space: this.space.id,
        set_products: this.selected.join(',')
      }
      this.$request('save', this.setproducts)
    }
  }
}
</script>



// WEBPACK FOOTER //
// LocationAssign.vue?ab0af53c